<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="12.797" height="14.852" viewBox="0 0 12.797 14.852">
		<path
			id="Path_29564"
			data-name="Path 29564"
			d="M11.966,12.52v2.311a.771.771,0,0,1-.77.77H4.52a.77.77,0,0,1-.77-.77V6.1a.771.771,0,0,1,.77-.77H5.8a6.2,6.2,0,0,1,1.027.085m5.135,7.1h2.311a.771.771,0,0,0,.77-.77V8.412A6.154,6.154,0,0,0,8.885,2.25H7.6a.771.771,0,0,0-.77.77v2.4m5.135,7.1H7.6a.77.77,0,0,1-.77-.77V5.417m8.216,4.536V8.669a2.311,2.311,0,0,0-2.311-2.311H11.71a.77.77,0,0,1-.77-.77V4.561A2.311,2.311,0,0,0,8.628,2.25h-.77"
			transform="translate(-3 -1.5)"
			fill="none"
			stroke="#5f60dc"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.5"
		/>
	</svg>
</template>

<script>
export default {
	name: 'LinkNotationSvg',
};
</script>

<style scoped lang="scss"></style>
